import Highway from '@dogstudio/highway';
import MainController from '../MainController';

class DefaultRenderer extends Highway.Renderer {
	constructor(properties) {
		// pass properties into constructor of parent class
		super(properties);

		// initialize class variables
		this.mainController = new MainController();
	}
	// Hooks/methods
	onEnter() {
		this.mainController.init();
	}
	onLeave() {
		this.mainController.destroy();
	}
	onEnterCompleted() {
		this.mainController.updateScroll();
		let mainScroll = this.mainController.getScroll();
		if (window.location.hash) {
			mainScroll.scrollTo(window.location.hash); // Get the hash without the '#' and find the matching element
			var id = window.location.hash.slice(1, window.location.hash.length);
			var target = document.getElementById(id); // If found, scroll to the element

			if (target) mainScroll.scrollTo(target);
			this.mainController.updateScroll();
		}
	}
	onLeaveCompleted() {}
}

// Don`t forget to export your renderer
export default DefaultRenderer;



// WEBPACK FOOTER //
// ./scripts/highway/renderers/default.js